module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/arrow-down-e935fdc68de7df585d8f2e02fa1ce242.svg&quot;;"